export const items = [
  "outsourcing_testimonialscustomers_firsttestimonial_description",
  "outsourcing_testimonialscustomers_secondtestimonial_description",
  "outsourcing_testimonialscustomers_thirdtestimonial_description",
  "outsourcing_testimonialscustomers_fourthtestimonial_description",
];
